export interface CharacterReference {
  faceDescription: string;
  hair: string;
  expression: string;
  skinTone: string;
  ageRange: string;
  ethnicityHint: string;
  clothing: string;
  pose: string;
}

export interface ImageReferences {
  styleReference: string;
  characterReference: string;
  environmentReference: string;
  compositionReference: string;
}

export interface UnifiedSceneState {
  initialPrompt: string;
  subject: string;
  environment: string;
  camera: string;
  lighting: string;
  mood: string;
  composition: string;
  palette: string;
  style: string;
  character?: CharacterReference;
  references?: ImageReferences;
}

export const createDefaultSceneState = (): UnifiedSceneState => ({
  initialPrompt: '',
  subject: '',
  environment: '',
  camera: '',
  lighting: '',
  mood: '',
  composition: '',
  palette: '',
  style: '',
});
